// @flow

import * as React from "react"
import {connect} from "react-redux"
import ClassNames from "classnames"
import {debounce} from "lodash"

import Config from "../../../config"
import PriceInput from "../../price-input"
import {toDinero} from "../../../util"
import Icon from "../../icon"
import {getFullItem} from "../../../reducers/baby-list-invoice"
import {
  updateBabyListInvoiceItem,
  removeBabyListInvoiceItem,
  removeBabyListInvoiceItemByOne,
} from "../../../actions/baby-list-invoice"
import type {
  SearchItem,
  Dispatch,
  BabyListInvoice,
  BabyListInvoiceItem,
  State as ReduxState,
} from "../../../types"

type Props = {
  +dispatch: Dispatch,
  +babyToken: string,
  +babyListInvoice: ?BabyListInvoice,
  +item: BabyListInvoiceItem,
  +searchItems: $ReadOnlyArray<SearchItem>,
  +isEditable: boolean,
  +isFinal: boolean,
}

type State = {
  name: string,
}

class BabyListInvoiceItemRow extends React.Component<Props, State> {
  saveName: () => void
  handleNameUpdate: (any) => void
  handleAmountDiscountUpdate: (string, string) => void
  handleRemoveByOne: () => void
  handleRemoveComplete: () => void

  static defaultProps = {
    isEditable: true,
    isFinal: false,
  }

  constructor(props: Props) {
    super(props)

    const fullItem = getFullItem(props.searchItems, props.item.babyListItemId)
    if (!fullItem) {
      this.state = {name: ""}
    } else {
      this.state = {
        name: fullItem.name,
      }
    }

    this.handleNameUpdate = this.handleNameUpdate.bind(this)
    this.saveName = debounce(this.saveName.bind(this), 1000)

    this.handleAmountDiscountUpdate = this.handleAmountDiscountUpdate.bind(this)
    this.handleRemoveByOne = this.handleRemoveByOne.bind(this)
    this.handleRemoveComplete = this.handleRemoveComplete.bind(this)
  }

  handleRemoveByOne() {
    const {dispatch, babyListInvoice, babyToken, item} = this.props
    if (babyListInvoice) {
      dispatch(
        removeBabyListInvoiceItemByOne(babyToken, babyListInvoice, item.id)
      )
    }
  }

  handleRemoveComplete() {
    const {dispatch, babyListInvoice, babyToken, item} = this.props
    if (babyListInvoice) {
      dispatch(
        removeBabyListInvoiceItem(babyToken, babyListInvoice.id, item.id)
      )
    }
  }

  handleNameUpdate(e: any) {
    const name: string = e.currentTarget.value
    this.setState({name})
    this.saveName()
  }

  saveName() {
    const {dispatch, babyListInvoice, babyToken, item} = this.props
    if (babyListInvoice) {
      dispatch(
        updateBabyListInvoiceItem(babyToken, babyListInvoice.id, item.id, {
          name: this.state.name,
        })
      )
    }
  }

  handleAmountDiscountUpdate(property: string, value: string) {
    const {dispatch, babyListInvoice, babyToken, item} = this.props
    if (babyListInvoice) {
      dispatch(
        updateBabyListInvoiceItem(babyToken, babyListInvoice.id, item.id, {
          amountDiscount: value,
        })
      )
    }
  }

  render() {
    const {item, isFinal} = this.props
    const costClass = ClassNames("text-right is-nfw", {
      "is-zero": item.cost === "0",
    })
    return (
      <tr key={`invoice-item-${item.id}`} className="invoice-row">
        <td>
          {isFinal && this.state.name}
          {!isFinal && (
            <div className="d-flex align-items-center">
              <input
                name="description"
                className="form-control form-control-sm"
                value={this.state.name}
                onChange={this.handleNameUpdate}
              />
            </div>
          )}
        </td>
        <td className="text-center">{item.amount}</td>
        <td className="text-right">
          {isFinal && item.amountDiscount.length > 1
            ? toDinero(item.amountDiscount).toFormat("$0,0.00")
            : null}
          {!isFinal && (
            <div className="d-flex align-items-center">
              <span className="d-inline-block mr-2">€</span>
              <PriceInput
                name="amountDiscount"
                className="form-control form-control-sm"
                value={item.amountDiscount}
                onChange={this.handleAmountDiscountUpdate}
              />
            </div>
          )}
        </td>
        <td className={costClass}>{toDinero(item.cost).toFormat("$0,0.00")}</td>
        <td className={costClass}>
          {toDinero(item.cost)
            .multiply(item.amount)
            .subtract(toDinero(item.amountDiscount))
            .toFormat("$0,0.00")}
        </td>
        {!isFinal ? (
          <td className="invoice-row-actions">
            {item.amount > 1 && (
              <button className="btn btn-icon" onClick={this.handleRemoveByOne}>
                <Icon name="icon-minus" />
              </button>
            )}
            <button
              className="btn btn-icon"
              onClick={this.handleRemoveComplete}
            >
              <Icon name="icon-bin" />
            </button>
          </td>
        ) : (
          <td className="invoice-row-actions py-4"> </td>
        )}
      </tr>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  babyToken: Config.data.babyToken,
  babyListInvoice: state.babyListInvoice.babyListInvoice,
  searchItems: state.babyListInvoice.searchItems,
})

export default connect(mapStateToProps)(BabyListInvoiceItemRow)
